import React from 'react';
import { Phone, MapPin, Clock } from 'lucide-react';
import { useBusinessInfo } from '../../hooks/useBusinessInfo';

const ContactInfoComponent = ({ config = {} }) => {
  const { businessInfo } = useBusinessInfo();
  const primaryColor = 'var(--theme-primary)';

  const showPhone = config.show_phone !== false;
  const showAddress = config.show_address !== false;
  const showHours = config.show_hours !== false;

  return (
    <section className="bg-white py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {showPhone && businessInfo?.phone && (
            <div className="text-center p-6 bg-gray-50 rounded-xl">
              <div 
                className="w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4"
                style={{ backgroundColor: `${primaryColor}15` }}
              >
                <Phone className="h-6 w-6" style={{ color: primaryColor }} />
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">Phone</h3>
              <a 
                href={`tel:${businessInfo.phone}`}
                className="text-gray-600 hover:underline"
                style={{ color: primaryColor }}
              >
                {businessInfo.phone}
              </a>
            </div>
          )}

          {showAddress && businessInfo?.address && (
            <div className="text-center p-6 bg-gray-50 rounded-xl">
              <div 
                className="w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4"
                style={{ backgroundColor: `${primaryColor}15` }}
              >
                <MapPin className="h-6 w-6" style={{ color: primaryColor }} />
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">Address</h3>
              <p className="text-gray-600 text-sm">
                {businessInfo.address}
                {businessInfo.city && `, ${businessInfo.city}`}
                {businessInfo.state && `, ${businessInfo.state}`}
                {businessInfo.zip && ` ${businessInfo.zip}`}
              </p>
            </div>
          )}

          {showHours && (
            <div className="text-center p-6 bg-gray-50 rounded-xl">
              <div 
                className="w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4"
                style={{ backgroundColor: `${primaryColor}15` }}
              >
                <Clock className="h-6 w-6" style={{ color: primaryColor }} />
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">Hours</h3>
              <p className="text-gray-600 text-sm">
                {businessInfo?.hours || 'Mon-Fri: 9AM - 6PM'}
              </p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ContactInfoComponent;
